import { Box, Stack, useTheme } from '@mui/material';
import Paper from '@/components/Paper';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Button from '@/components/Button';
import Image from 'next/image';

const SignupSection = () => {
  const { matches } = useResponsive();
  const theme = useTheme();
  return (
    <Box position="relative">
      <Box
        display={{ xs: 'none', lg: 'block' }}
        sx={{
          width: 569,
          height: 569,
          zIndex: 1,
          opacity: 0.18,
          borderRadius: 142.25,
          bottom: -102,
          right: -51,
          position: 'absolute',
          background: '#6188FF',
          filter: 'blur(67.5px)'
        }}
      />
      <Paper
        sx={{
          zIndex: 2,
          position: 'relative',
          py: matches({ xs: 6, lg: 19.5 }),
          px: matches({ xs: 0, lg: 24 }),
          pb: matches({ xs: 2, lg: null }),
          mt: matches({ xs: 6.5, lg: 36 })
        }}
        elevation={15}
      >
        <Stack justifyContent="center">
          <Stack
            gap={{ xs: 1.5, lg: 3 }}
            sx={{ px: matches({ xs: 4, lg: 0 }) }}
          >
            <Typography
              textAlign={matches({ xs: 'center', lg: 'start' })}
              variant={matches({ xs: 'body1', lg: 'h6' })}
              component="p"
            >
              <Typography
                weight="bolder"
                variant={matches({ xs: 'body1', lg: 'h6' })}
                component="span"
              >
                رابکس،
              </Typography>{' '}
              سکوی امن سرمایه‌گذاری
            </Typography>
            <Typography
              textAlign={matches({ xs: 'center', lg: 'start' })}
              variant={matches({ xs: 'body3', lg: 'body2' })}
              color={theme.palette.textColor.A80}
              sx={{
                [`${theme.breakpoints.down('sm')}`]: {
                  display: 'none'
                }
              }}
            >
              برای تجربه لذت بخش خرید و فروش ارز دیجیتال، رابکس را انتخاب کنید
            </Typography>
            <Typography
              variant="body3"
              textAlign={'center'}
              sx={{
                display: 'none',
                [`${theme.breakpoints.down('sm')}`]: {
                  display: 'block',
                  color: theme.palette.textColor.A60
                }
              }}
            >
              مقاله‌های علمی، ویدیوهای آموزشی و اخبار روز ارز دیجیتال
            </Typography>
            <Typography
              variant={matches({ xs: 'body3', lg: 'body2' })}
              textAlign={matches({ xs: 'center', lg: 'start' })}
              mt={{ xs: 0, lg: 4 }}
              mb={{ xs: 2, lg: 3 }}
              weight="bold"
              color="primary.A100"
            >
              شروع درآمدزایی با یک کلیک!
            </Typography>
            <Stack
              flexDirection="row"
              gap={{ xs: 3, lg: 4 }}
              justifyContent={{ xs: 'center', lg: 'start' }}
            >
              <Button
                onClick={() =>
                  (window.location.href = 'https://p.rabex.ir/auth/register')
                }
                size={matches({ xs: 'small', lg: 'medium' })}
                sx={{
                  width: matches({ xs: 142, lg: 166 })
                }}
                variant="contained"
                color="primary"
              >
                ثبت نام
              </Button>
              <Button
                onClick={() =>
                  (window.location.href = 'https://p.rabex.ir/auth/login')
                }
                size={matches({ xs: 'small', lg: 'medium' })}
                sx={{
                  width: matches({ xs: 112, lg: 166 })
                }}
                variant="outlined"
                color="primary"
              >
                ورود
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Image
          src="/assets/safeinvest.png"
          alt="signup"
          width={matches({ xs: 341, lg: 589 })}
          height={matches({ xs: 255, lg: 440 })}
          style={{
            position: matches({ xs: 'relative', lg: 'absolute' }),
            left: 0,
            bottom: '-15px',
            margin: matches({ xs: 'auto', lg: 'unset' }),
            display: matches({ xs: 'block', lg: 'unset' })
          }}
        />
      </Paper>
    </Box>
  );
};

export default SignupSection;
